import axios from "axios";
import store from "./store";
import { logoutUser } from "./actions/authActions";
import { BACKEND_API_BASE_URL } from "./utils/utility";
import { getImpersonatorSession, exitImpersonation } from "./utils/impersonation";

/**
 * CRA injects REACT_APP_* at build time.
 * Prefer the env var directly; fall back to shared utility constant
 * (which also reads REACT_APP_API_BASE_URL) so OAuth/PayPal links stay in sync.
 */
const resolveApiBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv && typeof fromEnv === "string" && fromEnv.trim()) {
    const trimmed = fromEnv.trim();
    return trimmed.endsWith("/") ? trimmed : `${trimmed}/`;
  }
  return BACKEND_API_BASE_URL;
};

const axiosInstance = axios.create({
  baseURL: resolveApiBaseUrl(),
});


// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (getImpersonatorSession()) {
        // Token expired mid-impersonation — restore the super-admin session cleanly
        exitImpersonation(store.dispatch, null);
        window.location.href = "/super-admin/subscriber";
      } else {
        store.dispatch(logoutUser());
        window.location.href = "/admin/login";
      }
    }

    // Feature not included in the user's plan — redirect to subscription page
    if (
      error.response?.status === 403 &&
      error.response?.data?.feature_locked === true
    ) {
      const msg =
        error.response.data.error ||
        "This feature is not included in your current plan. Please upgrade your subscription.";
      alert(msg);
      window.location.href = "/admin/manage-subscription";
    }

    // Plan quantity limit reached (events, seats, calendars)
    if (
      error.response?.status === 403 &&
      error.response?.data?.plan_limit_exceeded === true
    ) {
      const msg =
        error.response.data.error ||
        "You have reached a limit on your current plan. Please upgrade your subscription.";
      alert(msg);
      window.location.href = "/admin/manage-subscription";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
